import ListItemMovieContainer from '../../../DragAndDropItems/cont/ListItemMovieContainer'
import ListItemWithMovieContainer from '../../../DragAndDropItems/cont/ListItemWithMovieContainer'
import { AD, HIGHLIGHT, MOVIE, PUSH_LINK } from '../../../../constants/itemTypes'
import Translation from '../../../Translation/cont/Translation'
import config from '../../../../config.json'

const PushCreateDragSwitch = ({
    itemId,
    itemType,
    itemData,
    linkData=null,
    basicUrl,
    isSelected=false,
    canEdit,
    canDelete=false,
    deleteItem=false
}) => {
    if (!itemData) return ''

    if (itemType === MOVIE) {
        const pathnameEdit = canEdit ? `${config.routes.program.path}/${itemType}/${itemId}` : false
        return (
            <ListItemMovieContainer
                itemType={itemType}
                itemData={itemData}
                isSelected={isSelected}
                pathnameEdit={pathnameEdit}
                onDelete={canDelete && deleteItem ? () => deleteItem(itemId) : false}
            />
        )
    }

    if (itemType === AD || itemType === HIGHLIGHT) {
        const pathnameEdit = canEdit ? `${config.routes.program.path}/${itemType}/${itemId}` : false
        return (
            <ListItemWithMovieContainer
                itemType={itemType}
                itemData={itemData}
                isSelected={isSelected}
                pathnameEdit={pathnameEdit}
                onDelete={canDelete && deleteItem ? () => deleteItem(itemId) : false}
            />
        )
    }

    if (itemType === PUSH_LINK) {
        const url = linkData?.url ? linkData.url : '-'
        const destinationType = linkData?.destinationType === 'internal'
            ? 'Intern'
            : linkData?.destinationType === 'external'
                ? 'Extern'
                : '-'

        return (
            <div className={'item-poster-format cursor-pointer push_link' + (isSelected ? ' is-selected' : '')}>
                <div className="item-title-wrapper">
                    <h4 className="item-title text-xsmall-light">
                        <Translation id="push_create_content_item">Inhalt / URL</Translation>
                    </h4>
                </div>
                <div className="item-content text-xxsmall-light">
                    <p><strong>URL:</strong> {url}</p>
                    <p><strong>Ziel:</strong> {destinationType}</p>
                </div>
                {canDelete && deleteItem && (
                    <button
                        className="button button-delete-item"
                        onClick={() => deleteItem(itemId)}
                    >
                        <span className="text"><Translation id="remove_button"/></span>
                    </button>
                )}
            </div>
        )
    }

    return ''
}

export default PushCreateDragSwitch
